import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

interface StringMap {
  [key: string]: string;
}

export class ExtraHeadersInterceptor implements HttpInterceptor {
  constructor(
    private readonly triggerUrl: string,
    private readonly extraHeaders: StringMap
  ) {}

  public canHandle(url: string): boolean {
    return url.startsWith(this.triggerUrl);
  }

  public hasExtraHeaders(): boolean {
    return Object.keys(this.extraHeaders).length > 0;
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const url = req.url.toLowerCase();

    if (this.canHandle(url) && this.hasExtraHeaders()) {
      let headers: HttpHeaders = null;

      Object.keys(this.extraHeaders).forEach((key: string) => {
        headers = req.headers.set(key, this.extraHeaders[key]);
      });

      req = req.clone({ headers });
    }

    return next.handle(req);
  }
}
